module.exports = __webpack_public_path__ + "static/media/ic_锻炼方法.f4c4d9e9.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/ic_锻炼方法.svg
// module id = 404
// module chunks = 0